import { useEffect, useState } from "react";
import { database } from "../firebase/firebase";
import { ref, onValue } from "firebase/database";
import "../styles/main.css";

export default function DailySales(){

const [sales,setSales] = useState([]);
const [total,setTotal] = useState(0);

useEffect(()=>{

const invoiceRef = ref(database,"invoices");

onValue(invoiceRef,(snapshot)=>{

const data = snapshot.val();

if(!data){
setSales([]);
setTotal(0);
return;
}

const list = Object.values(data);

const today = new Date().toISOString().slice(0,10);

const todaySales = list.filter(inv =>
inv.date && inv.date.slice(0,10) === today
);

setSales(todaySales);

let sum = 0;

todaySales.forEach(inv=>{
sum += Number(inv.total || 0);
});

setTotal(sum);

});

},[]);

return(

<div className="mobile-app">

<div className="page-header">
<h2>Daily Sales</h2>
</div>

<div className="section">

<h3>Total Sales Today</h3>

<div className="stat-box">
₹ {total}
</div>

</div>

<div className="section">

<h3>Invoices</h3>

{sales.map((sale,index)=>(

<div key={index} className="card">

<p><b>Customer:</b> {sale.customer}</p>

<p><b>Item:</b> {sale.item}</p>

<p><b>Qty:</b> {sale.qty}</p>

<p><b>Total:</b> ₹{sale.total}</p>

</div>

))}

</div>

</div>

)

}